import { FRANCE_COMPETENCES_URL, MINISTERE_TRAVAIL_URL } from '@common/config';
import { useAppVersions } from '@common/hooks/src/use-app-versions';
import React from 'react';
import { Link } from 'react-router-dom';
import { LogoFC, LogoRF } from '../../../../shared/assets';
import './fc-footer.css';
import { getModalById } from '../modal';

interface FcFooterProps {
  appVersion: string;
}

export const FcFooter = ({ appVersion }: FcFooterProps) => {

  const { front, back, loading } = useAppVersions(appVersion);

  const navigationItems = [
    { text: 'Mentions légales', to: '/mentions-legales' },
    { text: 'Politique de confidentialité', to: '/politique-confidentialite' },
    { text: 'Conditions particulières d\'utilisation', to: '/conditions-utilisation' },
    { text: 'Contact', to: '/contact' },
    { text: 'Gestion des cookies', to: '/politique-cookies' },
  ];

  const modalConsent = getModalById('fr-consent-modal');

  return (
    <div className={'footer flex flex-col'}>
      <div className={'footer-top flex flex-col md:flex-row justify-between gap-8'}>
        <div className={'flex flex-row gap-8 m'}>
          <a target={'_blank'} href={MINISTERE_TRAVAIL_URL}>
            <img
              src={LogoRF as string}
              alt="Logo République Française"
              className="h-[60px]"
            />
          </a>
          <a target={'_blank'} href={FRANCE_COMPETENCES_URL}><img
            src={LogoFC as string}
            alt="Logo France compétences"
            className="h-[60px]"
          /></a>
        </div>
        <div className="flex my-auto md:mt-0 mt-4">
          <p className={'m-0 text-center md:text-left'}>Autorité nationale de financement et de régulation de la formation professionnelle et de l'apprentissage</p>
        </div>
      </div>

      <div className={'flex flex-row justify-center items-center my-6 mx-4 color-[#929292]'}>
        {navigationItems && navigationItems.map(({ text, to }, index) => (
          <div key={index} className="flex items-center">
            <Link className="link" to={to}>{text}</Link>
            <div className="h-6 w-px bg-[#929292] mx-3" />
          </div>
        ))}
        <div className="flex items-center" onClick={modalConsent.open}>
          <span className="text-[#929292] hover:text-[#535bf2] hover:underline hover:cursor-pointer font-medium">Gérer mes cookies</span>
        </div>
      </div>

      <div className="text-center">
        <p className="text-[#929292] font-normal not-italic uppercase !text-xs">
          MAP CLIENT v{front} {' - '} MAP SERVEUR v{loading ? '...' : back} {' - '} © FRANCE COMPETENCES
        </p>
      </div>
    </div>
  );
};